import React, {PureComponent} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import Linkedin from 'react-feather/dist/icons/linkedin.js';
import {connect} from 'react-redux';

import conf from '../../conf.js';
import {generate} from '../../routes.js';
import {isUserDo, isUserFreelance} from '../../../shared/services/userService.js';

import LogoText from '../../media/svg/logo-twineeds.svg';

import './Footer.scss';

const universes = [
  {label: 'Achats & Supply', code: 'purchase'},
  {label: 'Finance', code: 'finance'},
  {label: 'Ingénierie', code: 'engineering'},
  {label: 'Ressources Humaines', code: 'hr'},
];

class Footer extends PureComponent {
  static propTypes = {
    universes: PropTypes.array.isRequired,
    currentUser: PropTypes.object,
    isUserFreelance: PropTypes.bool,
    isUserDo: PropTypes.bool,
  };

  static defaultProps = {
    universes: [],
    currentUser: null,
    isUserFreelance: false,
    isUserDo: false,
  }

  constructor(props) {
    super(props);

    this.state = {
      collapses: [
        {
          key: 'freelances',
          title: 'Consultants Indépendants',
          links: universes.map((universe) => (
            {
              label: universe.label,
              route: {name: 'landing-freelance-' + universe.code}
            }
          )).concat({label: 'Nos partenaires', route: {name: 'partnerships'}}),
          show: !this.props.currentUser || this.props.isUserFreelance,
        },
        {
          key: 'companies',
          title: 'Entreprises',
          links: [
            {label: 'Nos services', route: {name: 'landing-company'}},
            {label: 'Déposer un besoin', route: {name: 'drop-need'}},
            {label: 'Consulter les profils', route: {name: props.currentUser !== null ? 'search' : 'register-do'}},
            {label: 'Cadre réglementaire', route: {name: 'legal'}}
          ],
          show: !this.props.currentUser || this.props.isUserDo,
        },
        {
          key: 'more',
          title: 'Découvrir',
          links: [
            {label: 'Notre vision', route: {name: 'our-vision'}},
            {label: 'Presse', route: {name: 'press'}},
            {label: 'Blog', route: {name: 'blog'}},
          ],
          show: true,
        },
        {
          key: 'bring-business',
          title: 'Apport d\'affaires',
          links: [
            {label: 'Remplir le formulaire', route: {name: 'bring-business'}},
          ],
          show: true,
        },
      ]
    };
  }

  render() {
    return <footer id="footer">
      <div className="container d-flex flex-column flex-md-row justify-content-between">
        <div className="coordinates d-flex flex-column">
          <div className="logo">
            <Link to={generate({name: 'homepage'})}>
              <LogoText/>
            </Link>
          </div>
          <p>{conf.address.street},<br/>{conf.address.postalCode} {conf.address.locality}</p>
          <p>
            Contactez-nous,<br/>
            Par téléphone : <a href={`tel:${conf.site.phone}`}>{conf.site.phone}</a><br/>
            Par email : <a href={`mailto:${conf.site.emails.contact}`}>{conf.site.emails.contact}</a><br/>
          </p>
        </div>
        <div className="links d-flex justify-content-between flex-column flex-lg-row mb-3 mb-lg-0">
          {
            this.state.collapses.filter(collapse => {
              return collapse.show;
            }).map((group, index) => {
              const listItems = group.links.map((link, index) => (
                <li key={index}>
                  <Link to={generate(link.route)}>
                    {link.label}
                  </Link>
                </li>
              ));

              if (group.key === 'more') {
                listItems.push(
                  <li key="linkedin" className="social-network">
                    <a
                      className="d-flex align-items-center"
                      href={conf.site.linkedinUrl}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <Linkedin/>
                    </a>
                  </li>
                );
              }

              return <div key={group.key}>
                <h4>{group.title}</h4>
                <ul>{listItems}</ul>
              </div>;
            })}
        </div>
      </div>
      <div className="d-flex flex-wrap justify-content-center">
        <span><Link to={generate({name: 'cgu'})}>CGU</Link></span>
        <span>|</span>
        <span>&copy; {conf.site.name}</span>
        <span>|</span>
        <span>
          Made with &#10084; by&nbsp;
          <a href="https://www.prestaconcept.net" rel="noopener noreferrer" target="_blank">Prestaconcept&copy;</a>
        </span>
      </div>
    </footer>;
  }
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
    isUserDo: isUserDo(state.currentUser.user),
    isUserFreelance: isUserFreelance(state.currentUser.user),
  })
)(Footer);
